import axios from "axios";
import axiosInstance from "./axiosInstance";

class OrgaoAtoInfralegalApi {
  cancelTokens = {
    getOrgaosAtoInfralegal: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getOrgaosAtoInfralegal() {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getOrgaosAtoInfralegal = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/orgaos_ato_infralegal`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getOrgaosAtoInfralegal = null;
    return data;
  }

  async getOrgaoBySlug(slug) {
    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/orgaos/slug/${slug}`
    );
    return data;
  }
}

export default OrgaoAtoInfralegalApi;
